// Gọi tất cả API backend qua file này
// Dùng relative path khi chạy production (IIS rewrite /api/* → backend)
// Dùng biến môi trường khi dev localhost (port khác nhau)
const BASE = process.env.REACT_APP_API_URL || ''

function getToken() {
  return localStorage.getItem('tchat_token')
}

async function request(method, path, body) {
  const headers = {}
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  const token = getToken()
  if (token) headers['Authorization'] = `Bearer ${token}`

  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  const data = await res.json()
  if (!res.ok) throw new Error(data.message || 'Lỗi server')
  return data
}

export const api = {
  // Auth
  register: (body) => request('POST', '/auth/register', body),
  login: (body) => request('POST', '/auth/login', body),
  verifyOtp: (body) => request('POST', '/auth/verify-otp', body),
  me: () => request('GET', '/auth/me'),
  centrifugoToken: () => request('GET', '/auth/centrifugo-token'),
  centrifugoSubToken: (channel) => request('GET', `/auth/centrifugo-sub-token?channel=${encodeURIComponent(channel)}`),
  updateMyName: (display_name) => request('PATCH', '/auth/me', { display_name }),
  saveFcmToken: (token, platform = 'web') => request('POST', '/auth/fcm-token', { token, platform }),
  deleteFcmToken: (token) => request('DELETE', '/auth/fcm-token', { token }),

  heartbeat: () => {
    // Không dùng request() để tránh throw khi tab bị blur
    const token = getToken()
    if (!token) return
    fetch(`${BASE}/api/auth/heartbeat`, {
      method: 'PATCH',
      headers: { 'Authorization': `Bearer ${token}` },
    }).catch(() => {})
  },

  // Conversations
  createDirect: (targetUserId) =>
    request('POST', '/conversations/direct', { target_user_id: targetUserId }),
  listConversations: () => request('GET', '/conversations'),
  markRead: (conversationId) =>
    request('POST', `/conversations/${conversationId}/read`, {}),
  deleteConversation: (conversationId) =>
    request('DELETE', `/conversations/${conversationId}`),
  getAutoReply: (conversationId) =>
    request('GET', `/conversations/${conversationId}/auto-reply`),
  setAutoReply: (conversationId, reply_content, is_active) =>
    request('PUT', `/conversations/${conversationId}/auto-reply`, { reply_content, is_active }),

  // Messages
  sendMessage: (conversationId, content, extra = {}) =>
    request('POST', `/conversations/${conversationId}/messages`, { content, ...extra }),
  getMessages: (conversationId, before) =>
    request('GET', `/conversations/${conversationId}/messages${before ? `?before=${before}` : ''}`),

  // Upload ảnh/file
  uploadFile: async (file) => {
    const token = getToken()
    const form = new FormData()
    form.append('file', file)
    const res = await fetch(`${BASE}/api/uploads`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: form,
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.message || 'Upload thất bại')
    return data
  },

  // URL ảnh/file (qua backend để kiểm tra auth)
  fileUrl: (url) => `${BASE}/api${url}`,

  // Users
  getAdmin: () => request('GET', '/users/admin'),
  searchUsers: (q) => request('GET', `/users/search?q=${encodeURIComponent(q)}`),

  // Gọi chuông
  ring: (conversationId) => request('POST', `/conversations/${conversationId}/ring`, {}),
  ringCancel: (conversationId, callResult = null, duration = 0) =>
    request('POST', `/conversations/${conversationId}/ring-cancel`,
      callResult ? { call_result: callResult, duration } : {}),
  webrtcSignal: (conversationId, event, data = {}) =>
    request('POST', `/conversations/${conversationId}/webrtc-signal`, { event, ...data }),

  // Thu hồi / xóa tin nhắn
  reactMessage: (conversationId, messageId, emoji) =>
    request('POST', `/conversations/${conversationId}/messages/${messageId}/reactions`, { emoji }),
  recallMessage: (conversationId, messageId) =>
    request('PATCH', `/conversations/${conversationId}/messages/${messageId}/recall`, {}),
  deleteMessage: (conversationId, messageId) =>
    request('DELETE', `/conversations/${conversationId}/messages/${messageId}`),
  clearMessages: (conversationId) =>
    request('DELETE', `/conversations/${conversationId}/messages`),
  setAutoDelete: (conversationId, days) =>
    request('PATCH', `/conversations/${conversationId}/auto-delete`, { days }),

  // Admin
  getPendingUsers: () => request('GET', '/admin/users/pending'),
  approveUser: (id) => request('POST', `/admin/users/${id}/approve`, {}),
  rejectUser: (id) => request('DELETE', `/admin/users/${id}/reject`),
  setMemo: (userId, memo) => request('PUT', `/admin/users/${userId}/memo`, { memo }),
  getPendingOtps: () => request('GET', '/admin/pending-otps'),
  getDevices: () => request('GET', '/admin/devices'),
  revokeDevice: (id) => request('DELETE', `/admin/devices/${id}`),

  // Tự động Forward
  getAutoForwardRules: () => request('GET', '/admin/auto-forward'),
  createAutoForwardRules: (source_user_ids, target_user_id) =>
    request('POST', '/admin/auto-forward', { source_user_ids, target_user_id }),
  toggleAutoForwardRule: (id) => request('PATCH', `/admin/auto-forward/${id}/toggle`, {}),
  deleteAutoForwardRule: (id) => request('DELETE', `/admin/auto-forward/${id}`),
}
